// YERİ: src/app/domains/site/sections/practice-areas.section.ts
// Uygulama Alanları (avukatlık) — ikon + başlık + açıklama kart grid'i.
// config.items[] yoksa avukat default'larıyla render eder.

import { inject, Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';
import { SiteChromeText } from '../core/site-chrome-text';

interface PracticeItem { icon?: string; title: string; description?: string; }

@Component({
  selector: 'sec-practice-areas',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="practice" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) {
            <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p>
          }
        </div>

        <div class="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          @for (item of items(); track item.title) {
            <div class="group relative rounded-2xl border border-neutral-200 bg-white p-7 transition hover:-translate-y-1 hover:shadow-xl dark:border-neutral-800 dark:bg-neutral-950">
              <div class="absolute left-0 top-7 h-9 w-1 rounded-r" style="background-color:var(--site-accent)"></div>
              <div class="flex size-12 items-center justify-center rounded-xl text-white" style="background-color:var(--site-primary)">
                <m-icon [name]="item.icon || 'scale'" size="md" />
              </div>
              <h3 class="mt-5 text-lg font-semibold text-neutral-900 dark:text-white">{{ item.title }}</h3>
              @if (item.description) {
                <p class="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ item.description }}</p>
              }
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class PracticeAreasSection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', this.text.t('fb.uzmanlik')));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.uygulamaAlanlarimiz')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', this.text.t('fb.genisYelpazedeHukukiHizmet')));
  protected items = computed<PracticeItem[]>(() => cfg<PracticeItem[]>(this.config(), 'items', [
    { icon: 'briefcase', title: 'Ticaret Hukuku', description: this.text.t('fb.sirketKurulusuSozlesmelerBirlesme') },
    { icon: 'users', title: 'Aile Hukuku', description: this.text.t('fb.bosanmaVelayetNafakaVe') },
    { icon: 'scale', title: 'Ceza Hukuku', description: this.text.t('fb.sorusturmaVeKovusturmaAsamalarinda') },
    { icon: 'house', title: 'Gayrimenkul Hukuku', description: this.text.t('fb.tapuKiraImarVe') },
    { icon: 'file-text', title: this.text.t('fb.isHukuku'), description: this.text.t('fb.isciIsverenIliskileriIs') },
    { icon: 'landmark', title: this.text.t('fb.icraIflas'), description: this.text.t('fb.alacakTakibiIcraIslemleri') },
  ]));
}
